import { useMutation, useQueryClient } from '@tanstack/react-query'
import { employeeRequest } from '@/shared/api'
import { type Employee, type EmployeeInput, EmployeeResponseSchema } from '../model/types'
import { employeeKeys } from './queries'

// PATCH /employees/:id (admin): деактивация доступа (is_active).
// version — optimistic lock; ответ — huma-обёртка {data: EmployeeView}.
export function useUpdateEmployee(id: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (input: EmployeeInput): Promise<Employee> => {
      const body = await employeeRequest<unknown>({
        method: 'PATCH',
        path: `/employees/${id}`,
        body: input,
      })
      return EmployeeResponseSchema.parse(body).data
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: employeeKeys.all })
    },
  })
}
